import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface MethodLibraryState {
    data: [] | null | any;
    totalRecords: number | null;
    totalPages: number | null;
}

const initialState: MethodLibraryState = {
    data: null,
    totalRecords: null,
    totalPages: null,
};

export const methodLibrarySlice = createSlice({
    name: 'MethodLibrary',
    initialState,
    reducers: {
        setMethodLibrary: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setMethodLibrary, reset } = methodLibrarySlice.actions;
export const getAllMethodLibraryDetails = (state: RootState) => state.methodLibrary.data;
export const getMethodLibraryTotalRecords = (state: RootState) => state.methodLibrary.totalRecords;
export default methodLibrarySlice.reducer;
